import React, { useEffect, useState } from "react";
// import { IoMdNotifications } from "react-icons/io";
// import { GrMail } from "react-icons/gr";
import Styles from "./SidePanel.module.css";
import { TfiAlignJustify } from "react-icons/tfi";
import { useDispatch, useSelector } from "react-redux";
import { SelectStudentPackage } from "../Action/CourseAction";
// import { useNavigate } from "react-router-dom";
import { FaChalkboardTeacher } from "react-icons/fa";

import { PurchasedPackages } from "../Action/PacakgeAction";
import { get_contact_batch } from "../Action/ContactBatchAction";
import { IoMdNotifications } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { RiBookOpenLine } from "react-icons/ri";

const TopBar = ({
  PageName,
  SetSideBarOpen,
  SidebarOpen,
  SidebarOpen2,
  SetSideBarOpen2,
  Materials,
  Mocks,
  Page,
  OpenSideMenu,
}) => {
  const [IsPaidPackages, setIsPaidPackages] = useState([]);
  const [SelectPack, setSelectPack] = useState("");
  const MobileScreen = window.innerWidth;
  const { OrdersRec } = useSelector((s) => s.ListOrdersReducer);
  const dispatch = useDispatch();
  const { PackageData } = useSelector((s) => s.SelectStudentPackageReducer);
  // const { purchasedPack } = useSelector((s) => s.PurchasedPackagesReducer);

  useEffect(() => {
    // if (!PackageData?._id && purchasedPack?.length) {
    //   dispatch(SelectStudentPackage(purchasedPack[purchasedPack?.length - 1]?.PackageId));
    //   setSelectPack(purchasedPack[purchasedPack?.length - 1]?.PackageId?._id);
    // }
    let PackagesBuy = [];
    let Package_Id = "";
    let Pack = {};
    if (OrdersRec) {
      for (let i = 0; i < OrdersRec?.length; i++) {
        if (OrdersRec[i]?.isPaid) {
          PackagesBuy.push({ ...OrdersRec[i] });
          Package_Id = OrdersRec[i]?.PackageId?._id;
          Pack = OrdersRec[i]?.PackageId;
        }
      }
    }

    setIsPaidPackages([...PackagesBuy]);
    if (!PackageData?._id) {
      dispatch(SelectStudentPackage(Pack));
      setSelectPack(Package_Id);
    }
  }, [OrdersRec]);

  useEffect(() => {
    dispatch(PurchasedPackages());
    dispatch(get_contact_batch());
  }, [dispatch]);

  const Navigate = useNavigate();

  return window.innerWidth <= 481 ? (
    <header className="header">
      <div className="header-left">
        <button className="menu-btn" id="menuBtn" onClick={OpenSideMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <h1 id="pageTitle">{Page}</h1>
      </div>
      <div className="header-right">
        <div className="pck_slt" id="courseSelector">
          <select
            name="SelectPack"
            value={PackageData?._id || SelectPack}
            onChange={(e) => {
              let Pack = IsPaidPackages?.find((ev) => {
                if (ev.PackageId?._id == e.target.value) return ev;
              });
               localStorage.setItem("std-pack",JSON.stringify(Pack?.PackageId))
              dispatch(SelectStudentPackage(Pack?.PackageId));
              setSelectPack(e.target.value);
            }}
            className="course-dropdown"
          >
            <option>PTE Academic Course</option>
            {IsPaidPackages?.map((eh, ib) => (
              <option key={ib + 567} value={eh?.PackageId?._id}>
                {eh?.PackageId?.Name}
              </option>
            ))}
          </select>
        </div>
        {/* <!-- <button className="icon-btn search-btn">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"/>
          <path d="m21 21-4.35-4.35"/>
      </svg>
  </button> --> */}
        <button className="icon-btn notification-btn">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
            <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
          </svg>
        </button>
      </div>
    </header>
  ) : (
    <div>
      <div style={{ marginTop: "-25px" }} className={Styles.TopBar}>
        {MobileScreen <= 780 ? (
          <h2
            onClick={() => SetSideBarOpen(!SidebarOpen)}
            style={{ cursor: "pointer" }}
          >
            <TfiAlignJustify />
          </h2>
        ) : (
          ""
        )}
        <div>
          <h2>{PageName}</h2>
        </div>
        {window.innerWidth <= 480 ? (
          ""
        ) : (
          <div className={Styles.PackageSelect}>
            <p
              className={Styles.Notification}
              onClick={() => Navigate("/Notification")}
            >
              <IoMdNotifications />
            </p>
            <select
              name="SelectPack"
              value={PackageData?._id || SelectPack}
              onChange={(e) => {
                let Pack = IsPaidPackages?.find((ev) => {
                  if (ev.PackageId?._id == e.target.value) return ev;
                });
                dispatch(SelectStudentPackage(Pack?.PackageId));
                setSelectPack(e.target.value);
              }}
            >
              <option>My Packages</option>
              {IsPaidPackages?.map((eh, ib) => (
                <option key={ib + 567} value={eh?.PackageId?._id}>
                  {eh?.PackageId?.Name}
                </option>
              ))}
            </select>
          </div>
        )}

        {MobileScreen <= 780 ? (
          <h2
            onClick={() => SetSideBarOpen2(!SidebarOpen2)}
            style={{ cursor: "pointer" }}
          >
            <div
              className="menu-icon"
              id="openRight"
              style={{ fontSize: "27px", color: "black", cursor: "pointer" }}
            >
              {Materials || Mocks ? (
                <RiBookOpenLine />
              ) : (
                <FaChalkboardTeacher />
              )}
            </div>
          </h2>
        ) : (
          ""
        )}
      </div>

      {window.innerWidth >= 481 ? (
        ""
      ) : (
        <div className={Styles.PackageSelect}>
          <p
            className={Styles.Notification}
            onClick={() => Navigate("/Notification")}
          >
            <IoMdNotifications />
          </p>
          <select
            name="SelectPack"
            value={PackageData?._id || SelectPack}
            onChange={(e) => {
              let Pack = IsPaidPackages?.find((ev) => {
                if (ev.PackageId?._id == e.target.value) return ev;
              });
              dispatch(SelectStudentPackage(Pack?.PackageId));
              setSelectPack(e.target.value);
            }}
          >
            <option>Packages</option>
            {IsPaidPackages?.map((eh, i) => (
              <option key={i + 812390} value={eh?.PackageId?._id}>
                {eh?.PackageId?.Name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default TopBar;
